module.exports = __webpack_public_path__ + "img/trust@2x.be337c6d.png";